import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocale } from '../../../components/special/LanguageProvider';
import { apiPostCall } from '../../../components/special/apiCall';
import InputDropDownList from 'components/input/InputDropDownList';
import InputCheckBox from 'components/input/InputCheckBox';
import { useToasts } from 'react-toast-notifications';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

const SettingClaimCancel = ({ definition, documentedcancelationreasonList, collectionDataHandlingList, cancellationReasonList }) => {
    const [settingValue, setSettingValue] = useState(JSON.parse(definition.value));
    const [oldValue, setOldValue] = useState(definition.value);
    const { t } = useLocale();
    const { addToast } = useToasts();
    const [workingData, setWorkingData] = useState({
        documentedCancellationReasonTypeId: settingValue.documentedCancellationReasonTypeId,
        collectionDataHandlingId: settingValue.collectionDataHandlingId,
        removeFaultDebtorRegistry: settingValue.removeFaultDebtorRegistry,
        overrideCancellationAgreement: settingValue.overrideCancellationAgreement,
        skipCostSettlement: settingValue.skipCostSettlement,
        skipLetter: settingValue.skipLetter,
        availableCancellationReasons: settingValue.availableCancellationReasons || []
    });
    
    const updateSetting = (jsonValue) => {
        apiPostCall(BASE_URL + '/admin/setting/save', { ...definition, value: jsonValue }).then(res => {
            setOldValue(jsonValue)
            if (res && res.error) {
                addToast(res.error.message, { appearance: 'error', autoDismiss: false })
            }
            else {
                addToast(t('Breyting fyrir "') + t(definition.name) + t('" vistuð.'), { appearance: 'success', autoDismiss: true })
            }
        });
    }


    const onUpdateCancellationValue = (idx, value) => {
       // console.log("cancelchange", idx, value);
        let newList = { ...workingData };
        if (value) {
            newList.availableCancellationReasons.push(idx);
        }
        else {
            var indexOfItem = workingData.availableCancellationReasons.indexOf(idx);
            //console.log("indexofitem", indexOfItem);
            if (indexOfItem > -1) {
                newList.availableCancellationReasons.splice(indexOfItem, 1);
            }
        }
        //console.log("newlistafter", newList);
        OnUpdateValue(newList);
        //setSettingValue(value);
    }

    const OnUpdateValue = (value) => {
        let newList = { ...workingData };
        //console.log("newlist", value);
        //console.log("newliststring", JSON.stringify(newList));
        //console.log ("onupdatevalue", value);
        setWorkingData(value);
        let jsonValue = JSON.stringify(value);
        if (jsonValue.localeCompare(oldValue) !== 0) {
            //console.log("compare", jsonValue, oldValue, jsonValue.localeCompare(oldValue));
            updateSetting(jsonValue);
        }
    }

    const onExit = () => {
        let jsonValue = JSON.stringify(settingValue);
        if (jsonValue.localeCompare(oldValue) !== 0) {
            //console.log("compare", jsonValue, oldValue, jsonValue.localeCompare(oldValue));
            updateSetting(jsonValue);
        }
    }



    return (
        <div>
            <div className="table-wrap form">
                <table className="table">
                    <colgroup>
                        <col />
                        <col />
                    </colgroup>
                    <thead>
                        <tr>
                            <th className="no-border">{t(definition.name)}</th>
                            <th className="no-border"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="no-border">{"Skjalfest ástæða"}</td>
                            <td className="no-border"><InputDropDownList
                                list={documentedcancelationreasonList}
                                keyField="itemID"
                                displayField={(item) => { return item.name + " " + (item.data ? "(" + item.data.key + ")" : ""); }}
                                defaultValue={workingData.documentedCancellationReasonTypeId}
                                onChange={(value) => OnUpdateValue({ ...workingData, documentedCancellationReasonTypeId: (value ? Number(value) : null) })}
                                nullable={true}
                                nullableItem={{ itemID: null, name: "" }} />
                            </td>

                        </tr>
                        <tr>
                            <td className="no-border">{"Meðferð innheimtugagna"}</td>
                            <td className="no-border"><InputDropDownList
                                list={collectionDataHandlingList}
                                keyField="itemID"
                                displayField={(item) => { return item.name + " " + (item.data ? "(" + item.data.key + ")" : ""); }}
                                defaultValue={workingData.collectionDataHandlingId}
                                onChange={(value) => OnUpdateValue({ ...workingData, collectionDataHandlingId: (value ? Number(value) : null) })}
                                nullable={true}
                                nullableItem={{ itemID: null, name: "" }} />
                            </td>

                        </tr>
                        <tr>
                            <td className="no-border">{"Ástæða niðurfellingar"}</td>
                            <td>
                                <table>
                                    <tbody>
                                        {cancellationReasonList.map((item, index) =>
                                            <tr key={index}>
                                                <td>{item.name}&nbsp;&nbsp;</td>
                                                <td>
                                                    <InputCheckBox value={workingData.availableCancellationReasons.includes(item.itemID)} onChange={(value) => onUpdateCancellationValue(item.itemID, value)} />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                            </td>
                        </tr>
                        <tr>
                            <td className="no-border">{"Afskrá af vanskilaskrá"}</td>
                            <td className="no-border">  <InputCheckBox value={workingData.removeFaultDebtorRegistry} onChange={(value) => OnUpdateValue({ ...workingData, removeFaultDebtorRegistry: value })} /></td>
                        </tr>
                        <tr>
                            <td className="no-border">{"Yfirskrifa niðurfellingarsamning"}</td>
                            <td className="no-border">  <InputCheckBox value={workingData.overrideCancellationAgreement} onChange={(value) => OnUpdateValue({ ...workingData, overrideCancellationAgreement: value })} /></td>
                        </tr>
                        <tr>
                            <td className="no-border">{"Sleppa uppgjöri"}</td>
                            <td className="no-border">  <InputCheckBox value={workingData.skipCostSettlement} onChange={(value) => OnUpdateValue({ ...workingData, skipCostSettlement: value })} /></td>
                        </tr>
                        <tr>
                            <td className="no-border">{"Sleppa bréfi"}</td>
                            <td className="no-border">  <InputCheckBox value={workingData.skipLetter} onChange={(value) => OnUpdateValue({ ...workingData, skipLetter: value })} /></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>);
};


export default SettingClaimCancel;
